import * as React from 'react';
import { ISingleAudioPlayerProps } from '../../../SingleAudioPlayer.types';
// Note: this skin is not supported, but there are sites which require it. Skin stub is added to avoid site crashes.
const MusicPlayer: React.FC<ISingleAudioPlayerProps> = props => {
  return <div id={props.id} />;
};

export default MusicPlayer;
